import { Component, ViewChild  } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos'
import { ProductosElaboradosProvider } from '../../providers/productos-elaborados/productos-elaborados'
import { LoadingController } from 'ionic-angular';
import { ProductosElaboradosContenidoProvider } from '../../providers/productos-elaborados-contenido/productos-elaborados-contenido'

import { SelectSearchable } from 'ionic-select-searchable';
import { productosSearch } from '../../models/productosSearch'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';

@IonicPage()
@Component({
  selector: 'page-productos-por-grupos',
  templateUrl: 'productos-por-grupos.html',
  providers: [ AuthService,ElectronService ]
})
export class ProductosPorGruposPage {

  productosPorGrupos = []
  // listaProductosElaborados:productosElaboradosModelo[] = []
  listaProductosElaborados:productosSearch[] = []
  listaProductosElaborado:productosSearch  
  productosElaboradosId
  gruposProductosId
  tipoProducto
  productoId
  companiasId

  productosPorGruposId

  editarProductosPorGrupos
  loader

  // listaProductos:productosElaboradosModelo[] = []
  listaProductos:productosSearch[] = []
  listaProducto:productosSearch
  listaGrupos
  productoVisible:boolean = false
  productoElaboradoVisible:boolean = false
  items:valores[] = []
  allItems: any;
  allItemsGroup: any;
  buscar: any = "";
  buscarGrupos: any = "";
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  modo:boolean = true
  uuId
  myMapafn:string
  @ViewChild('myMap') myMap ;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: ProductosPorGruposProvider,
    private storage: Storage,
    public loadingCtrl: LoadingController,
    public servicioElaborado: ProductosElaboradosProvider,
    public servicioProductosElaborados:ProductosElaboradosContenidoProvider,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    private _electronService: ElectronService ) {
 
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
          
        }
      })
      this.items.push({nombre:"Productos", valor:"P"},{nombre:"Productos elaborados",valor:"E"})

      this.productoVisible = false
      this.productoElaboradoVisible = false 
      let tmodo = MODO_DESCONECTADO
      if(tmodo){
   
        let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-ProductosPorGrupos',RUTA_MODO_DESCONECTADO) 
        if(resultado){

          this.productosPorGrupos = []
          this.listaProductos = []
          this.listaGrupos = []
          this.buscarDatosProductos(resultado)
          this.allItemsGroup = JSON.parse(resultado)
     
          let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-gruposProductos',RUTA_MODO_DESCONECTADO) 
          if(resultadoNuevo){
            this.listaGrupos =JSON.parse(resultadoNuevo)
          }
         }
        
      }else{
        console.log('no debería entrar por este lado')
        this.cargarProductos()
      }
  }

  productosChange(event: { component: SelectSearchable, value: any }) {
    console.log('valor:', event.value);
}

  getItems(event: any): void {
    if(!this.allItems){
      let valores = this.listaProductos
      this.allItems = valores;
    } 
      this.listaProductos = this.allItems.filter((item) => {
        return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
      });
}

onEvent(event: string, item: any){ 

if (event === 'onTextChange') {
 
 let valor = this.getItems(this.buscar);
 if(valor){
      item = valor
} 
}
}

getItemsGrupo(event: any): void {
  if(!this.allItemsGroup){
    let valores = this.productosPorGrupos
    this.allItemsGroup = valores;
  } 
    this.productosPorGrupos = this.allItemsGroup.filter((item) => {
      return item.nombreProducto.toLowerCase().indexOf(this.buscarGrupos.toLowerCase()) > -1;
    });
}

onEventlistaGrupos(event: string, item: any){ 

  if (event === 'onTextChange') {
   
   let valor = this.getItemsGrupo(this.buscarGrupos);
   if(valor){
        item = valor
  } 
  }
  }

  valoresSelect(data:string){
    if(data['valor'] === "P"){
      this.cargarComboProductos()
    }else {
      this.cargarComboProductosElaborados()
    }
  }

  valoresSelectGrupo(data:any){
    
    if(data['valor'] === "0"){
      
    }else {
      
    }
  }
  cargarComboProductosElaborados(){
    // this.storage.get('companiasId').then((val) => {
    //   this.companiasId = val
    //     this.servicioElaborado.buscarProductoElaboradosCompania(val)
    //     .subscribe( 
    //       res => {
            
    //         this.productoVisible = false
    //         this.productoElaboradoVisible = true  
    //         this.listaProductosElaborados = res[0]
    //         // this.listaProductosElaborados = res
    //         // let valores = []
    //         // valores = res[0][0]
         
    //         // let busquedaCompuesta = 'E' 
    //         // console.log(res)
    //         // this.listaProductosElaborados = valores.filter(e => e.tipo.indexOf(busquedaCompuesta) != -1)
          
    //       },
    //       err => {
    //         let alert = this.alertControllers.create({
    //           title: 'Error',
    //           subTitle: 'No se pudieron listar los productos Elaborados, intente luego',
    //           buttons: ['Cerrar']
    //         });
    //         alert.present();
    //       }
    //     )})
    let tmodo = MODO_DESCONECTADO
    if(tmodo){
      
       let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-Elaborados',RUTA_MODO_DESCONECTADO) 
     // let resultado = this._electronService.ipcRenderer.sendSync('buscar-productosporgrupos-recorrer',RUTA_MODO_DESCONECTADO) 
      if(resultado){
        
        this.productoVisible = false
        this.productoElaboradoVisible = true  
        
        this.listaProductosElaborados =JSON.parse(resultado)
       }
      
    }else{
      this.storage.get('companiasId').then((val) => {
        this.companiasId = val
          this.servicioElaborado.buscarProductoElaboradosCompania(val)
          .subscribe( 
            res => {
              
              this.productoVisible = false
              this.productoElaboradoVisible = true  
      
              this.listaProductosElaborados = res[0]
              // this.listaProductosElaborados = res
              // let valores = []
              // valores = res[0][0]
           
              // let busquedaCompuesta = 'E' 
              // console.log(res)
              // this.listaProductosElaborados = valores.filter(e => e.tipo.indexOf(busquedaCompuesta) != -1)
            
            },
            err => {
              let alert = this.alertControllers.create({
                title: 'Error',
                subTitle: 'No se pudieron listar los productos Elaborados, intente luego',
                buttons: ['Cerrar']
              });
              alert.present();
            }
          )})
    }
    
  }
  cargarComboProductos(){
        // // this.servicio.buscarProductos()}
     
        // this.storage.get('companiasId').then((val) => {
          
        // this.companiasId = val
        // this.servicio.buscarProductoCompania(val)
        // .subscribe( 
        //   res => {
        //     this.productoVisible = true
        //     this.productoElaboradoVisible = false
        //     this.listaProductos = res[0]
        //   },
        //   err => {
        //     let alert = this.alertControllers.create({
        //       title: 'Error',
        //       subTitle: 'No se pudieron listar los productos, intente luego',
        //       buttons: ['Cerrar']
        //     });
        //     alert.present();
        //   }
        // )})
                // this.servicio.buscarProductos()}
     
                this.storage.get('companiasId').then((val) => {
          
                  this.companiasId = val
                  let modo
                  if(MODO_DESCONECTADO === undefined){
                    modo = true
                  }else{
                    this.modo = MODO_DESCONECTADO
                  }
                  if(this.modo){
                    // buscar-informacion-mododesconectado-ProductoCompania
                    let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos',val) 
                    
                    if(resultadoNuevo){
                      this.productoVisible = true
                      this.productoElaboradoVisible = false
                     
                      this.listaProductos =JSON.parse(resultadoNuevo) 
                      console.log('listaProductos')
                      console.log(this.listaProductos)
                     
                   }
                  }else{
                  this.servicio.buscarProductoCompania(val)
                  .subscribe( 
                    res => {
                      this.productoVisible = true
                      this.productoElaboradoVisible = false
                     
                      this.listaProductos = res[0]
                    },
                    err => {
                      let alert = this.alertControllers.create({
                        title: 'Error',
                        subTitle: 'No se pudieron listar los productos, intente luego',
                        buttons: ['Cerrar']
                      });
                      alert.present();
                    }
                  )
                }
          
                })
  }

  cargarProductos() {
    this.productosPorGrupos = []
    this.listaProductos = []
    this.listaGrupos = []
    
    this.cargarProductosElaboradosContenidos()

    
    // this.servicio.buscarGrupos()
    this.storage.get('companiasId').then((val) => {
      this.companiasId = val
    this.servicio.buscarGruposCompaniasId(val)
    .subscribe( 
      res => this.listaGrupos = res,
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar los grupos, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )
  })

  }


cargarProductosElaboradosContenidos() {
  
  this.productosPorGrupos = []

  this.storage.get('companiasId').then((val) => {
    let valores = []
    valores['companiasId'] = val
    this.companiasId = val 
    this.servicio.busca(valores)
    .subscribe( 
      res => {
      
       this.productosPorGrupos = res
       this.allItemsGroup = res
     
     
      },
      err => {
      console.log('No se pudieron traer los datos, intente luego')
      }  
    )     
  })
}

buscarUuidGrupos(){
  
  let data = []
  let valorComparar = Number(this.gruposProductosId)
  for(let k=0;k< this.listaGrupos.length;k++){
    if(k === valorComparar){
      
      data.push({
        nombreGrupoProducto:this.listaGrupos[k].nombreGrupoProducto,
        uuid : this.listaGrupos[k].uuid === undefined ? undefined : this.listaGrupos[k].uuid,
        gruposProductosId : this.listaGrupos[k].gruposProductosId === undefined ? "0" : this.listaGrupos[k].gruposProductosId
      }) 
      
    }
  }
  
  return data 
  
}
  guardar() {
    let dataUuidGrupo = this.buscarUuidGrupos()

    let datosGruposProductos: any = {}
    if(MODO_DESCONECTADO){
      
    
    
     datosGruposProductos = {
        gruposProductosId:  dataUuidGrupo[0].gruposProductosId,
        nombreGrupoProducto:dataUuidGrupo[0].nombreGrupoProducto,
        gruposProductosIdUuid:dataUuidGrupo[0].uuid,
        tipo: this.listaProductos.length > 0 ? "P" : "E" ,
        productoId: this.listaProductos.length > 0 ?
        this.productoId.productosId != "0" ? this.productoId.productosId : this.productoId.uuid :
        this.productosElaboradosId.productosElaboradosId != "0" ? this.productosElaboradosId.productosElaboradosId : this.productosElaboradosId.uuid,
        productosPorGruposId: this.productosPorGruposId == undefined ? "0" : this.productosPorGruposId,
        uuId:this.uuId    
      }
    }else{
      this.loader = this.loadingCtrl.create({});
      this.loader.present();
 
      
      datosGruposProductos = {
        gruposProductosId:   dataUuidGrupo[0].gruposProductosId,
        tipoProducto: this.listaProductos.length > 0 ? "P" : "E" ,
        productoId: this.listaProductos.length > 0 ? this.productoId.productosId : this.productosElaboradosId.productosElaboradosId,
        queHago: "I",
        nombreTabla: "productosPorGrupos",
        name: "dataDynamicCrud"
      }
    }
    

    // productoId: this.listaProductos.length > 0 ? this.productoId.productosId : this.productosElaboradosId.productosElaboradosId,
    this.storage.get('companiasId').then((val) => {
      
      datosGruposProductos['companiasId'] = val == undefined ? this.companiasId : val 
   
      if(MODO_DESCONECTADO){

        // let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-ProductosPorGrupos-guardar',datosGruposProductos) 
        
        let resultado = this._electronService.ipcRenderer.sendSync('guardar-mododesconectado-todos',datosGruposProductos,'c:\\bd','productosPorGrupos') 
         
            let valoresnuevos = resultado 
            this.limpiar()
            // this.loader.dismiss()
          
            let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-ProductosPorGrupos',RUTA_MODO_DESCONECTADO) 
            
            if(resultadoNuevo){
              this.buscarDatosProductos(resultadoNuevo)
             
            }
 
       }else{
         console.log('guardando no debería entrar...')
        if(this.editarProductosPorGrupos){
          this.editarProductosPorGrupos = false;
          datosGruposProductos['queHago'] = 'A'
          
          this.editarProduct(datosGruposProductos)
        }else{
          
          this.guardarProducto(datosGruposProductos)
        }
       }
      
    });
  }

  editarProduct(datosProducto) {
    datosProducto['productosPorGruposId'] = this.productosPorGruposId

    this.servicio.actualizar(datosProducto)
    .subscribe(
      res => this.procesarResultado(),
      err => this.mostrarMensajeDeError('No se pudo actualizar el producto, intente luego')
    )
  }

  guardarProducto(datos){

    this.servicio.guardar(datos)
    .subscribe(
      res => this.procesarResultado(),
      err => this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
    )

  }

  limpiar() {
    this.gruposProductosId = ''
    this.tipoProducto = ''
    this.productoId = ''
    this.buscarGrupos = ''
    this.editarProductosPorGrupos = false
    this.productosPorGruposId = 0
    this.uuId = undefined    
  }

  editar(item){
    this.gruposProductosId = item.gruposProductosId 
    this.productoId = item.productoId 
    this.tipoProducto = item.tipoProducto 
    this.productosPorGruposId = item.productosPorGruposId

    this.editarProductosPorGrupos = true
    this.productosPorGruposId = item.productosPorGruposId
    this.uuId = item.uuid
  }

  eliminar(item) {
    // this.loader = this.loadingCtrl.create({});
    // this.loader.present();

    // this.servicio.eliminar(item)
    // .subscribe(
    //   res => this.procesarResultado(),
    //   err => this.mostrarMensajeDeError('No se pudo eliminar el grupo producto, intente luego')
    // )
    this.loader = this.loadingCtrl.create({});
    this.loader.present();

    if(MODO_DESCONECTADO){
      let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-ProductosPorGrupos-eliminar',item) 
      if(resultadoNuevo){
        
        this.limpiar()
        this.loader.dismiss()
        this.productosPorGrupos = []
        this.listaProductos = []
        this.listaGrupos = []
        
        let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-ProductosPorGrupos',RUTA_MODO_DESCONECTADO) 
        if(resultado){
          this.limpiar()
          this.productosPorGrupos = []
          this.listaProductos = []
          this.listaGrupos = []
          this.productosPorGrupos = JSON.parse(resultado)
          this.allItemsGroup = JSON.parse(resultado)
 
   
        }
        

     }
    }else{
    
    this.servicio.eliminar(item)
    .subscribe(
      res => this.procesarResultado(),
      err => this.mostrarMensajeDeError('No se pudo eliminar el grupo producto, intente luego')
    )
  }
  }

  procesarResultado() {
    this.limpiar()
    this.loader.dismiss()
    this.cargarProductos()
  }

  mostrarMensajeDeError(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Error',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();

    this.loader.dismiss()
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  buscarDatosProductos(resultado:any){
    this.productosPorGrupos = JSON.parse(resultado)

    // let resultadolistaProductos = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-ProductosPorGrupos',RUTA_MODO_DESCONECTADO)
    // 
    let resultadolistaProductos = this.productosPorGrupos
if(!resultadolistaProductos){
}else {
   // buscar-informacion-mododesconectado-cajaGrupo
   // buscar-informacion-mododesconectado-cajaProductos
   // buscar-informacion-mododesconectado-cajaCliente
   // let resultadolistaProductosData = JSON.parse(resultadolistaProductos)
   for(let y=0;y<resultadolistaProductos.length;y++){
 
       if(resultadolistaProductos[y]['productoId']!==""){
         
   
           let id = resultadolistaProductos[y]['productoId']
           let tipo = resultadolistaProductos[y]['tipo'] === undefined ? resultadolistaProductos[y]['tipoProducto'] : resultadolistaProductos[y]['tipo']
          let gruposProductosId = resultadolistaProductos[y]['gruposProductosId']
           let resultadolistaProductosValorDevolver = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-nombreProducto',id,tipo,gruposProductosId)
           
          if(resultadolistaProductosValorDevolver.length>0){
               resultadolistaProductos[y]['nombreProducto'] = resultadolistaProductosValorDevolver[0].nombreProducto
               resultadolistaProductos[y]['valorImpuesto'] = resultadolistaProductosValorDevolver[0].valorImpuesto
               resultadolistaProductos[y]['valorVenta'] = resultadolistaProductosValorDevolver[0].valorVenta
               resultadolistaProductos[y]['valorProducto'] = resultadolistaProductosValorDevolver[0].valorProducto
               resultadolistaProductos[y]['existenciasActuales'] = resultadolistaProductosValorDevolver[0].existenciasActuales
               resultadolistaProductos[y]['imagenLocal'] = resultadolistaProductosValorDevolver[0].imagenLocal
               resultadolistaProductos[y]['tipoProducto'] = resultadolistaProductosValorDevolver[0].tipoProducto
               resultadolistaProductos[y]['imagen'] = resultadolistaProductosValorDevolver[0].imagen
               resultadolistaProductos[y]['tiponombre'] = resultadolistaProductosValorDevolver[0].tiponombre
               resultadolistaProductos[y]['nombreGrupoProducto'] = resultadolistaProductosValorDevolver[0].nombreGrupoProducto
           }
       }

   }

   this.productosPorGrupos = resultadolistaProductos
}    
  }
}

class valores{
  public nombre:string;
  public valor:string;
}



// WEBPACK FOOTER //
// ./src/pages/productos-por-grupos/productos-por-grupos.ts